import cx from "classnames";
import { NavLink } from "react-router-dom";

interface ItemProps {
  /** Where does it redirect to. */
  to: string;

  /** Label */
  label: string;

  /** Whether to display a notification ping */
  notify?: boolean;
  intentPreload?: () => void;
}

interface TabsProps {
  items: ItemProps[];
  activeTo?: string;
}

/** Tabs */
export const Tabs = ({ items, activeTo }: TabsProps) => {
  return (
    <div className="flex gap-4 overflow-auto px-6 pt-1 text-secondary">
      {items.map(({ to, label, notify, intentPreload }) => (
        <NavLink
          key={to}
          to={to}
          className={({ isActive }) =>
            cx(
              "relative whitespace-nowrap pb-[10px] text-bold2 transition-opacity active:opacity-60",
              (isActive && !activeTo) || activeTo === to
                ? "border-b-2 border-brand-color text-brand-color"
                : undefined,
              activeTo === to && "opacity-60",
            )
          }
          onPointerDown={intentPreload}
          onMouseEnter={intentPreload}
          onFocus={intentPreload}
        >
          {notify && (
            <div className="absolute -right-[7px] top-[-1px] h-2 w-2 rounded-full bg-red outline outline-[3px] outline-white">
              <div className="h-2 w-2 rounded-full bg-red" />
            </div>
          )}
          {label}
        </NavLink>
      ))}
    </div>
  );
};
